import Swiper from "swiper";
import SwiperCore, {FreeMode, Lazy, Manipulation} from "swiper";
import OverflowSlider from "./overflow-slider";
import VideoHls from "../components/video-hls";

SwiperCore.use([Lazy, FreeMode, Manipulation]);

class TimelineSlider {

    loading = false;
    btnSlider: Swiper;
    freeModeSlider: OverflowSlider;
    timelineHomePage: Swiper;


    constructor() {


        this.btnSlider = new Swiper('.b-either .schedule-days', {
            slidesPerView: 'auto',
            spaceBetween: 30,
            freeMode: false,
            updateOnWindowResize: true,
            breakpoints: {
                992: {
                    spaceBetween: 56,
                }
            }
        });

        const sectionSlideId = $('.b-either .program-tags-slider-item.active').data('slickId');
        if (sectionSlideId && this.btnSlider) {
            this.btnSlider.slideTo(sectionSlideId);
            //this.btnSlider[1].slideTo(sectionSlideId);
        }

        /* timeline pagination */
        // this.setButtonProperty();
        //  $(document).on('click', '.show-more-timeline', this.hasMore.bind(this));

        if (document.querySelector('.mobile-either-slider-wrapper')) {
            /* home page */
            this.timelineHomePage = new Swiper('.mobile-either-slider-wrapper', {
                slidesPerView: 'auto',
                spaceBetween: 12,
                freeMode: {
                    enabled: true,
                    sticky: true
                },
                centeredSlides: false,
                lazy: true,
                breakpoints: {
                    992: {
                        centeredSlides: true,
                        spaceBetween: 35,
                    }
                },
                on: {
                    init: (swiper) => {
                        this.freeModeSlider = new OverflowSlider(swiper, {
                            enableBreakpointDown: 567,
                            container: 21,
                            spaceBetween: 7,
                            freeMode: false,
                            magnet: true,

                            onInit: (freeMode) => {
                                const currentMovie = $('.mobile-either-current-slider').data('index') ?? 1;
                                freeMode.slideTo(currentMovie)
                            },
                            slideChangeTransitionEnd: freeMode => {
                                swiper.realIndex = freeMode.activeIndex - 1;
                                let itemClass = '.mobile-either-slider-item'
                                this.onSlideChange(swiper, itemClass);
                                if (typeof sectionSlideId !== 'undefined')
                                    this.loadSlides(swiper);
                            }
                        });
                    },
                    slideChangeTransitionEnd: swiper => {
                        let itemClass = '.mobile-either-slider-item'
                        this.onSlideChange(swiper, itemClass)
                        if (typeof sectionSlideId !== 'undefined')
                            this.loadSlides(swiper);
                    },
                }
            });

            const mSlickId = $('.mobile-either-current-slider').data('slickId');
            if (mSlickId) {
                this.timelineHomePage.slideTo(mSlickId);
            }
        }

        /*
        if (document.querySelector('.timeline-slider-wrapper')) {

            /!* timeline slider *!/
            const swiper = new Swiper('.timeline-slider-wrapper', {
                slidesPerView: 'auto',
                spaceBetween: 35,
                freeMode: false,
                on: {
                    slideChangeTransitionEnd: swiper => {
                        let itemClass = '.timeline-slider-item'
                        this.onSlideChange(swiper, itemClass)
                    }
                }
            });
            const slideId = $('.timeline-slider-current-item').data('slickId');
            if (slideId) {
                swiper.slideTo(slideId);
            }
            ($('.timeline-slider-controls .btn-next') as any).on('click', () => {
                swiper.slideNext();
            });
            ($('.timeline-slider-controls .btn-prev') as any).on('click', () => {
                swiper.slidePrev();
            });
        }*/
    }


    loadSlides(swiper) {
        if (swiper.slides.length / 2 <= swiper.activeIndex && this.loading === false) {
            this.loading = true;
            this.getNextDayHtml(result => {
                if (result) {
                    if (swiper.destroyed == true) {
                        this.freeModeSlider.appendSlide(result);
                    } else {
                        this.timelineHomePage.appendSlide(result)
                    }
                    this.loading = false;
                }
            })
        }

        let activeDate = $('.mobile-either-slider-item.swiper-slide-active').data('date');
        let currentDayBtn = $('.schedule-days .program-tags-slider-item[data-date=' + activeDate + ']')
        let currentDay = currentDayBtn.data('slick-id')

        if (this.btnSlider) {
            $('.schedule-days .program-tags-slider-item a').removeClass('active')
            this.btnSlider.slideTo(currentDay);

            currentDayBtn.find('a').addClass('active');
        }
    }

    getNextDayHtml(callback) {
        let currentDate = $('.schedule-days-links[data-current-date]').data('current-date');
        if (typeof currentDate === 'undefined') {
            callback(false)
        }
        const url = this.getNextDayLink(currentDate);
        if (url) {
            const elementSelector = '.mobile-either-slider.swiper-wrapper';
            $.ajax({
                type: 'GET',
                url: '/schedule/?date=' + url,
                data: {'AJAX': 'Y'},
                dataType: 'html',
                success: data => {
                    let elements = $(data).find(elementSelector);
                    $('.schedule-days-links').data('current-date', url)
                    callback(elements.children())
                }
            })
        } else {
            callback(false)
        }
    }

    getNextDayLink(current) {
        let result = 0;
        let btns = $('.schedule-days .btn-tag-link');
        btns.each((i, e) => {
            if ($(e).parent().data('date') === current) {
                result = i + 1;
                return;
            }
        });

        return btns.length === result
            ? false
            : $(btns[result]).parent().data('date');
    }

    onSlideChange(swiper, itemClass) {
        let videoWrappers = $(itemClass + ' .mobile-either-slider-video');
        videoWrappers.removeClass('active');
        videoWrappers.html('');
        let currentElement = $($('.mobile-either-slider-item.swiper-slide')[swiper.realIndex]).find('.card-image-playable')
        if (currentElement.length) {
            let wrapper = currentElement.find('.mobile-either-slider-video');

            setTimeout(() =>{
                new VideoHls(wrapper[0], {
                    onPlayStart: () => {
                        videoWrappers.removeClass('active');
                        wrapper.addClass('active');
                    }
                });
            }, 500)
        }
    }

    /*setButtonProperty() {
        if ($('.timeline-item.d-none').length === 0) {
            setTimeout(() => {
                let nextDayLink = this.getNextDayLink();
                if (nextDayLink)
                    $('.show-more-timeline').attr('href', nextDayLink);
                else
                    $('.show-more-timeline').prop('disabled', true).css('opacity', .4);
            }, 1000);
        }
    }
*/
    /*    hasMore() {
            $(`.timeline-item.d-none:lt(4)`).removeClass('d-none');
            this.setButtonProperty();
        }*/
}

export default TimelineSlider;
